import { makeAutoObservable, runInAction } from 'mobx';
import ScoReflectClient from './ScoReflectClient';

interface IMap {
  ID: string;
  Title: string;
  Difficulty: number;
}

interface IUser {
  UserID: string;
  NickName: string;
  ShortID: string;
  Maps: {
    ID: string;
    Difficulty: number;
    Time: string;
  }[];
  Score: number;
  Opened: boolean;
}

interface IBeatSaber {
  UserID: string;
  NickName: string;
  ShortID: string;
  Score: number;
  Opened: boolean;
}

interface IWarpoint {
  UserID: string;
  NickName: string;
  ShortID: string;
  AVG: number;
  Kills: number;
  Deaths: number;
  KD: number;
  Score: number;
  Opened: boolean;
  IsTeam: boolean;
}

class RatingStore {
  maps: IMap[] = [];
  users: IUser[] = [];
  prize: number = 15000;
  dayPrize: number = 0;
  rating: string = "Assetto Corsa";
  beatsaber: IBeatSaber[] = [];
  warpoint: IWarpoint[] = [];
  isTeam: boolean = true;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchUsers() {
    try {
      const response = await ScoReflectClient.request('/rating/');
      let users: IUser[] = response.data;

      runInAction(() => {
        this.users = users.sort((u1, u2) => u1.Score < u2.Score ? 1 : -1);
      });
    } catch (e) {
      console.log(e);
    }
  }

  async fetchBeatSaber() {
    try {
      const response = await ScoReflectClient.request('/rating/beatsaber');
      let users: IBeatSaber[] = response.data;

      runInAction(() => {
        this.beatsaber = users.sort((u1, u2) => u1.Score < u2.Score ? 1 : -1);
      });
    } catch (e) {
      console.log(e);
    }
  }

  async fetchWarpoint() {
    try {
      const response = await ScoReflectClient.request('/rating/warpoint');
      let users: IWarpoint[] = response.data;

      runInAction(() => {
        this.warpoint = users.sort((u1, u2) => u1.Score < u2.Score ? 1 : -1);
      });
    } catch (e) {
      console.log(e);
    }
  }

  async setRating(rating: string) {
    if (rating === "Beat Saber") {
      await this.fetchBeatSaber();
    }
    if (rating === "Warpoint") {
      await this.fetchWarpoint();
    }
    if (rating === "Assetto Corsa") {
      await this.fetchMaps();
      await this.fetchUsers();
    }
    runInAction(() => {
      
    this.rating = rating;
    })
  }

  async fetchMaps() {
    try {
      const response = await ScoReflectClient.request('/rating/maps');
      if (response.data === null) return;

      let maps: IMap[] = response.data;

      runInAction(() => {
        this.maps = maps.sort((m1, m2) => m1.Difficulty > m2.Difficulty ? 1 : -1);
      });
    } catch (e) {
      console.log(e);
    }
  }

  async fetchPrize() {
    try {
      const response = await ScoReflectClient.request('/prize');
      
      runInAction(() => {
        this.prize = response.data;
      });
    } catch (e) {
      console.log(e);
    }
  }

  async fetchDayPrize() {
    try {
      const response = await ScoReflectClient.request('/day-prize');
      
      runInAction(() => {
        this.dayPrize = response.data;
      });
    } catch (e) {
      console.log(e);
    }
  }
}

export default new RatingStore();